var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 540",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M313,468.5H199c-67.82,0-123-55.18-123-123c0-13.81,11.19-25,25-25s25,11.19,25,25c0,40.25,32.75,73,73,73h114    c40.25,0,73-32.75,73-73c0-13.81,11.19-25,25-25s25,11.19,25,25C436,413.32,380.82,468.5,313,468.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M256,348.5c-13.81,0-25-11.19-25-25v-255c0-13.81,11.19-25,25-25s25,11.19,25,25v255C281,337.31,269.81,348.5,256,348.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M256,361.5c-0.06,0-0.11,0-0.17,0c-7.01-0.05-13.69-3.04-18.39-8.25l-118.25-131c-9.25-10.25-8.44-26.06,1.81-35.31    c10.25-9.25,26.06-8.44,35.31,1.81l99.94,110.72L355.92,192c9.39-10.12,25.21-10.72,35.33-1.33c10.12,9.39,10.72,25.21,1.33,35.33    L274.33,353.5C269.6,358.6,262.95,361.5,256,361.5z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.79ab212f.svg";
export { ForwardRef as ReactComponent };